import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgHouseInsuranceFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#house-insurance-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M23.29 46.459c12.553 0 22.73-10.177 22.73-22.73S35.842 1 23.29 1 .56 11.176.56 23.73c0 12.552 10.177 22.729 22.73 22.729"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5D897C",
        d: "M5.842 41.326H46.98c-3.485 2.424-7.215 5.054-16.806 5.054-8.887 0-12.608 3.448-21.298 3.448-10.667 0-9.97-6.767-3.034-8.502"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#89B081",
        d: "M4.174 41.69c2.305 0 4.173-1.817 4.173-4.058s-1.868-4.058-4.173-4.058S0 35.391 0 37.632s1.869 4.058 4.174 4.058"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#89B081",
        d: "M6.031 36.86c1.867 0 3.38-1.471 3.38-3.285s-1.513-3.286-3.38-3.286-3.38 1.471-3.38 3.285 1.513 3.286 3.38 3.286"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M11.93 10.906h-.814l-7.84 7.736 16.485.022-7.829-7.758z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F2F9FF",
        d: "M21.321 41.432H5.646V18.678l7.834-7.741 7.841 7.741z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M13.253 22.899a2.198 2.198 0 1 0-.002-4.395 2.198 2.198 0 0 0 .002 4.395"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50769A",
        d: "M11.375 19.614c.656-1.053 2.01-1.394 3.028-.761 1.02.632 1.313 1.998.657 3.05-.085.14-.185.27-.299.381.35-.962.013-2.066-.867-2.607-.88-.55-2.015-.364-2.725.374.051-.151.12-.291.208-.437z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "m18.952 18.67-7.834-7.764h22.458l7.834 7.736z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M39.808 18.642H21.273v22.792h18.535zM12.48 29.528H9.967v2.324h2.511z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M12.48 31.364H9.967v4.007h2.511zM16.246 29.528h-2.51v2.324h2.51z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M16.246 31.364h-2.51v4.007h2.51z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#42947C",
        d: "M55.804 32.437c-5.9.043-8.933-2.044-9.921-2.945-.989.901-4.14 2.986-10.037 2.945 0 0-.778 9.64.76 14.412 1.126 3.494 5.34 5.774 8.957 7.33l.263.123s.29-.128.682-.304c3.518-1.551 7.453-3.79 8.536-7.149 1.538-4.772.76-14.412.76-14.412"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#35654B",
        fillRule: "evenodd",
        d: "M45.867 42.363v5.49c-5.064 1.111-7.726-.508-9.82-4.615a3 3 0 0 0-.18-.312c.146 1.448.378 2.817.734 3.923 1.127 3.494 5.34 5.774 8.957 7.33l.264.123s.29-.128.681-.304l.178-.08a50 50 0 0 0 .705-.318c3.27-1.532 6.663-3.668 7.656-6.749 1.43-4.435.858-13.074.77-14.272l-.024-.038c-1.083 5.808-3.384 10.455-6.47 9.529l-3.451.297z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m43.033 45.385 7.148-7.148L52 40.055l-7.148 7.148z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M44.85 47.224 40 42.374l1.818-1.82 4.85 4.851z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `house-insurance-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgHouseInsuranceFidelityLow;
